import React from "react";
import {
  AutocompleteItem,
  FeedbackAutocompleteItem,
  AppAutocompleteItem,
  UserAutocompleteItem
} from "../../Models/AutocompleteItem";
import styles from "../../Styles/SearchBarContainer.module.scss";
import { AutocompleteItemType } from "../../Constants/LayoutEnums";
import FeedbackAutocompleteResult from "./Results/FeedbackAutocompleteResult";
import AppAutocompleteResult from "./Results/AppAutocompleteResult";
import UserAutocompleteResult from "./Results/UserAutocompleteResult";

const uuid = require("uuid");

type Props = {
  items: AutocompleteItem[];
  selectedItemIndex?: number;
  onItemClick: (item: AutocompleteItem) => void;
  clearAutocompleteIfLoaded: () => void;
};

export default class AutocompleteResults extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    document.addEventListener("click", () => {
      props.clearAutocompleteIfLoaded();
    });
  }

  render() {
    return (
      <div className={styles.autocompleteContainer}>
        <div className={styles.autocompleteItems}>
          {this.props.items.map((el, index) => {
            const isSelected = index === this.props.selectedItemIndex;
            switch (el.type) {
              case AutocompleteItemType.Feedback: {
                const feedbackResult = el as FeedbackAutocompleteItem;
                return (
                  <FeedbackAutocompleteResult
                    item={feedbackResult}
                    key={uuid()}
                    isSelected={isSelected}
                    isRedirecting={false}
                    clearAutocompleteIfLoaded={this.props.clearAutocompleteIfLoaded}
                    onClick={this.props.onItemClick}
                  />
                );
              }
              case AutocompleteItemType.App: {
                const appResult = el as AppAutocompleteItem;
                return (
                  <AppAutocompleteResult
                    item={appResult}
                    key={uuid()}
                    isSelected={isSelected}
                    isRedirecting={false}
                    clearAutocompleteIfLoaded={this.props.clearAutocompleteIfLoaded}
                    onClick={this.props.onItemClick}
                  />
                );
              }
              case AutocompleteItemType.User: {
                const userResult = el as UserAutocompleteItem;
                return (
                  <UserAutocompleteResult
                    item={userResult}
                    key={uuid()}
                    isSelected={isSelected}
                    isRedirecting={false}
                    clearAutocompleteIfLoaded={this.props.clearAutocompleteIfLoaded}
                    onClick={this.props.onItemClick}
                  />
                );
              }
              default:
                return null;
            }
          })}
        </div>
      </div>
    );
  }
}
